'use client'
import React from 'react';
import { Link } from 'react-router-dom'; // Use react-router-dom for routing.
import { useState } from 'react';
import ServiceDetailsImg from '../../assets/images/services/MAGNET.png'
import ServiceDetailsImg1 from '../../assets/images/services/double-shaft-shredder.png'
import ServiceDetailsImg2 from '../../assets/images/services/service-details-images-1-2.jpg'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import ImageGallery from "react-image-gallery";
import 'react-image-gallery/styles/css/image-gallery.css';
import table, { Table } from 'react-bootstrap'
import SEOHelmet from '../../components/SEO/SEOHelmet';
// import ModalVideo from 'react-modal-video';
// import 'react-modal-video/css/modal-video.min.css';
const mainSlider = {
    width: '90%',
}
const DoubleShaftShredder = () => {
    const images = [
        {
            original: ServiceDetailsImg1,
            thumbnail: ServiceDetailsImg1,
            originalAlt: "Slide 1",
            thumbnailAlt: "Thumbnail 1",
        },


    ]

    const [projectInfo] = useState({

        rating: 5,
    });
    const [socialLinks] = useState([
        { href: "https://www.facebook.com/profile.php?id=61573443062800", iconClass: "icon-facebook-f" },
        { href: "https://x.com/design79356", iconClass: "icon-Vector" },
        { href: "https://www.instagram.com/ramanasteels/", iconClass: "icon-instagram" },
        { href: "https://in.pinterest.com/Ramanasteels/", iconClass: "icon-pinterest" },
    ]);
    const [serviceDetails] = useState({

        title: "Double Shaft Scrap Shredder",
        text2: "A double shaft scrap shredder is a powerful industrial machine designed to shred various materials into smaller pieces.It has two parallel shaft with interlocking cutting disks that rotate in opposite directions to efficiently shred bulky items such as plastic,wood,rubber and metal.Double shaft shreddders are widely used in recycling facilities, manufacturing plants, and waste management centers to reduce the size of waste materials for further processing or disposal.",
        points: [
            "Automatic Start triangle connection",
            "Automatic protection of overload,automate turn off the machinery meanwhile Automatic reverting running,once there is leakage or power off, cabinet controller will be automate turn off",


        ]
    });

    return (
        <React.Fragment>
            <SEOHelmet 
                title="Heavy-Duty Double Shaft Scrap Shredder"
                description="Powerful double shaft shredder for efficient metal and industrial waste shredding. High torque, low noise, and durable performance for recycling operations."
                keywords="double shaft shredder, metal shredder, industrial shredder, scrap shredder, waste processing"
                canonicalUrl="https://ramanasteels.com/double-shaft-shredder"
            />
            {/* Service Details Start */}
            <section className="service-details">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8 col-lg-7">
                            <div className="service-details__left">
                                <div className="service-details__content-one">

                                    <p className="service-details__text-1">{serviceDetails.text1}</p>
                                    <div className="justify-content-center mt-4">
                                        <div className="card p-3 rounded" style={mainSlider}>
                                            <ImageGallery
                                                items={images}
                                                showPlayButton={false}
                                                showFullscreenButton={true}
                                                showThumbnails={true}
                                                autoPlay={true}
                                                slideInterval={4000}
                                                showNav={true}
                                                additionalClass="img-slider"
                                            />
                                        </div>
                                    </div>
                                    <h1 className="service-details__title-one">{serviceDetails.title}</h1>
                                </div>
                                <div className="service-details__content-two">
                                    <h4 className="service-details__title-two">{serviceDetails.title2}</h4>
                                    <p className="service-details__text-2">{serviceDetails.text2}</p>
                                    <ul className="list-unstyled service-details__points">
                                        <h3>Features</h3>
                                        {serviceDetails.points.map((point, index) => (
                                            <li key={index}>
                                                <div className="icon">
                                                    <i className="far fa-check" />
                                                </div>
                                                <div className="text">
                                                    <p>{point}</p>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div>
                                    <Table responsive>
                                        <thead style={{ color: '#FFFFFF', background: '#2F8CD6' }}><tr> <th>Model   </th>
                                            <th>Reduce type</th>
                                            <th>Body size </th>
                                            <th>Production</th>
                                            <th>Motor</th>
                                        </tr></thead>
                                        <tbody>
                                            <tr>
                                                <td>RD-1500</td>
                                                <td>ZSY355</td>
                                                <td>4800x2330x1850</td>
                                                <td>5-6(T/H)</td>
                                                <td>55x2</td>
                                            </tr>
                                            <tr>
                                                <td>RD-1800</td>
                                                <td>ZSY560</td>
                                                <td>5200x2600x3200</td>
                                                <td>6-8(T/H)</td>
                                                <td>110x2</td>
                                            </tr>
                                            <tr>
                                                <td>RD-2000</td>
                                                <td>ZSY630</td>
                                                <td>5600x2800x3300</td>
                                                <td>10-15(T/H)</td>
                                                <td>132x2</td>
                                            </tr>

                                        </tbody>
                                    </Table>
                                </div>
                                {/* <div className="service-details__images-box">
                                    <div className="row">
                                        {serviceDetails.images.map((image, index) => (
                                            <div key={index} className="col-xl-6 col-lg-6">
                                                <div className="service-details__images-single">
                                                    <img src={image} alt="" />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="service-details__content-three">
                                    <h4 className="service-details__title-four">{serviceDetails.content3Title}</h4>
                                    <p className="service-details__text-3">{serviceDetails.text3}</p>
                                    <p className="service-details__text-4">{serviceDetails.text4}</p>
                                </div> */}
                                {/* <div className="service-details__feature-box">
                                    <div className="row">
                                        {serviceDetails.features.map((feature, index) => (
                                            <div key={index} className="col-xl-6">
                                                <div className="service-details__feature-single">
                                                    <div className="service-details__feature-icon-box">
                                                        <div className="service-details__feature-icon">
                                                            <span className={feature.icon} />
                                                        </div>
                                                        <h4 className="service-details__feature-title">
                                                            <Link to={feature.link}>{feature.title}</Link>
                                                        </h4>
                                                    </div>
                                                    <p className="service-details__feature-text">{feature.text}</p>
                                                    <Link to={feature.link} className="service-details__read-more">
                                                        Read more <span className="icon-dubble-arrow-right" />
                                                    </Link>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-5">
                            <div className="project-details__sidebar">
                                <div className="project-details__project-info">
                                    <h3 className="project-details__project-info-title">
                                        Product Information
                                    </h3>
                                    <ul className="list-unstyled project-details__project-info-list">
                                        <li>
                                            <h5>Origin:</h5>
                                            <h5>China{/* {projectInfo.category} */}</h5>
                                        </li>
                                        <li>
                                            <h5>Make:</h5>
                                            <h5>Gaode{/* {projectInfo.customer} */}</h5>
                                        </li>
                                        <li>
                                            <h5>Used In:</h5>
                                            <h5> Heavy duty scrap<br /> processing{/* {projectInfo.startDate} */}</h5>
                                        </li>
                                        <li>
                                            <h5>Rating:</h5>
                                            <div className="rating">
                                                {Array(projectInfo.rating)
                                                    .fill(0)
                                                    .map((_, index) => (
                                                        <span className="icon-star" key={index}></span>
                                                    ))}
                                            </div>
                                        </li>
                                    </ul>
                                    <div className="project-details__social">
                                        {socialLinks.map((link, index) => (
                                            <Link to={link.href} key={index}>
                                                <span className={link.iconClass}></span>
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="project-details__need-help">
                                {/* <div className="project-details__need-help-img">
                                    <img
                                        src="/assets/images/project/project-details-need-help-img.jpg"
                                        alt="Need Help"
                                    />
                                </div> */}
                                <div className="project-details__need-help-icon">
                                    <span className="icon-call"></span>
                                </div>
                                <p className="project-details__need-help-sub-title">
                                    Contact Us
                                </p>
                                <h3 className="project-details__need-help-number">
                                    <Link to="tel:+91-9815902561"> +91-9815902561</Link>
                                </h3>
                            </div>

                        </div>

                    </div>
                </div>
            </section>
            {/* Service Details End */}
        </React.Fragment>
    );
};

export default DoubleShaftShredder;
